<template>
  <h1 class="text-center">Stats</h1>
</template>

<script>
export default {
  name: "Stats"
}
</script>

<style scoped>

</style>